module.exports = __webpack_public_path__ + "static/media/44587792_2199902043418308_7078041833917382656_o.c00da0b7.jpg";